import React, { useCallback, useMemo } from "react";
import {
  Button,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { useDispatch } from "react-redux";

import { render } from "../utils/render";
import {
  reviewByMod,
  reviewByAdmin,
  reviewStopInternal,
  reviewExtension,
} from "../../../reducer/internalResearch/action";

// InstitutionalProjectModal v2 (refactor 2026-05-15) — đa năng cho tất cả
// hành động trên đề tài Cơ sở. `open` là object `{ <key>: true, ...extra }`
// với key khớp `modalPropertiesDict` (xem utils/render.js).
//
// Pattern đồng bộ với StudentProjectModal: form tự dispatch action; modal
// chỉ truyền `dispatch`, `actions`, `handleClose` xuống renderProps.
function InstitutionalProjectModal({ open, setOpen, year, type, detail }) {
  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    setOpen(null);
  }, [setOpen]);

  const modalProperties = useMemo(() => (open ? render(open) : null), [open]);

  const actions = useMemo(
    () => ({
      reviewByMod,
      reviewByAdmin,
      reviewStopInternal,
      reviewExtension,
    }),
    []
  );

  const renderProps = useMemo(
    () => ({
      open,
      type,
      year,
      detail,
      dispatch,
      actions,
      handleClose,
    }),
    [open, type, year, detail, dispatch, actions, handleClose]
  );

  if (!open || !modalProperties) return null;

  return (
    <Dialog fullWidth open={!!open} maxWidth={modalProperties.size || "md"} onClose={handleClose}>
      <DialogTitle style={{ padding: "4px 12px 4px 24px" }}>
        <Grid container alignItems="center">
          <Grid item xs={11}>
            <Typography variant="h5">
              <b>{modalProperties.title}</b>
            </Typography>
          </Grid>
          <Grid item xs={1} style={{ textAlign: "right" }}>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <Divider />

      <DialogContent style={{ padding: 0 }}>
        {modalProperties.form(renderProps)}
      </DialogContent>

      <DialogActions style={{ padding: "8px 24px" }}>
        {modalProperties.actionButtons(renderProps).map((item, idx) => (
          <React.Fragment key={`btn-${idx}`}>
            {item?.closeButton ? (
              <Button variant="outlined" startIcon={<Close />} onClick={handleClose}>
                Đóng
              </Button>
            ) : item?.disabledText ? (
              <Tooltip title={item.disabledText}>
                <span>
                  <Button disabled {...item.props}>{item.content}</Button>
                </span>
              </Tooltip>
            ) : (
              <Button {...item.props}>{item.content}</Button>
            )}
          </React.Fragment>
        ))}
      </DialogActions>
    </Dialog>
  );
}

export default InstitutionalProjectModal;
